import { useMemo } from 'react';

import { type QueryKey } from '@tanstack/react-query';

type QueryEnabledCriteria = Array<string | number | boolean | undefined | QueryKey | unknown>;
export function useQueryDisabled(criteria: QueryEnabledCriteria): boolean {
    return useMemo(() => {
        return Boolean(criteria.some((item) => !item));
    }, [criteria]);
}
